
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, EventEmitter, inject, Input, input, OnChanges, Output, signal } from '@angular/core';
import { EntryService } from '../entry.service';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';

export interface Filter {
  types: string[];
  description: string;
}
export type TableNames = 'Domains' | 'Macromolecules' | 'TextAnnotations';


@Component({
  selector: 'interactive-left-table',
  templateUrl: './interactive-left-table.component.html',
  styleUrl: './interactive-left-table.component.css',
  standalone: false
})
export class InteractiveLeftTableComponent implements OnChanges {

  public tedDomainData = input.required<any[]>();

  @Output()
  handleSelectedCard:EventEmitter<Object> = new EventEmitter();

  public readonly tabName = input.required<TableNames>();

  public tableData?: any;
  public currentTableFilter: string[] = [];

  public selectedRowCard = signal<any>({});
  public filters = signal<Filter[]>([]);
  public selectedFilter = signal<Filter>({} as Filter);
  public rowCards = signal<any[]>([]);
  public startNumber = signal<number>(1);
  private mappedTableRows = signal<any[]>([]);
  public uniqueTedDomains = signal<any[]>([])

  public entryService = inject(EntryService);
  constructor( public gaService: GoogleAnalyticsService) {
    // entryService.activeDomain is a page-wide singleton event, only ever emitted by the
    // Domains tab's own components (domains-tab.component.ts, ted-domains.component.ts) when
    // TED domain data loads there — using a tedNumber scheme specific to real TED domains.
    // mat-tab-group keeps every visited tab's component alive in the background, so this
    // instance keeps receiving that event even when it's actually backing the Macromolecules
    // or Text Annotations sidebar, whose tedNumber is a different, synthetic per-chain index.
    // Un-scoped, an unrelated Domains-tab load landing at the wrong moment silently resets
    // selectedRowCard to undefined here (no match found), making the sidebar fall back to the
    // first card and look like the user's own chain selection was lost.
    this.entryService.activeDomain.subscribe((data:any)=>{
     if (this.tabName() !== 'Domains') return;
     const activeDomain = this.uniqueTedDomains().find(domain=>domain.tedNumber === data.tedNumber);
     this.selectedRowCard.set(activeDomain);
    })
  }

  async ngOnChanges(): Promise<void> {
    const previousSelectedTedNumber = this.selectedRowCard()?.tedNumber;
    this.uniqueTedDomains.set([]);

    const seenTedNumbers = new Set<number>();

    for (const item of this.tedDomainData()) {
      if (!seenTedNumbers.has(item.tedNumber)) {
        this.uniqueTedDomains().push(item);
        seenTedNumbers.add(item.tedNumber);
      }
    }

    const preservedSelection = this.uniqueTedDomains().find(
      (item) => item.tedNumber === previousSelectedTedNumber
    );
    this.selectedRowCard.set(preservedSelection || this.uniqueTedDomains()[0]);
  }

  onCardClick(card: any): void {
    this.selectedRowCard.set(card);
    this.handleSelectedCard.emit(card);
  }
}
